module.exports = __webpack_public_path__ + "img/yinhao.988bfe54.svg";